import { component } from 'picoapp'

export default component((node,ctx) => {
    const { currentBrand } = node.dataset
    const matchingBrand = window.theme.brands.find(brand => brand.vendor_name.toLowerCase() === currentBrand.toLowerCase())

    if (matchingBrand) insertBrandDescription(matchingBrand)

    function insertBrandDescription(brand) {
        node.innerHTML = `${brand.description}`
    }
})